import { render, staticRenderFns } from "./ufis.vue?vue&type=template&id=08532de2"
import script from "./ufis.vue?vue&type=script&lang=js"
export * from "./ufis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports